import React from 'react';

const styles: Record<string, React.CSSProperties> = {
  container: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  tabsContainer: {},
  tabs: {
    padding: '0 5vw',
  },
};

export default styles;
